/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NbIconLibraries } from '@nebular/theme';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { RoutingState } from './generic/routing-state';
import { environment } from 'environments/environment';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  
  cookieMessage: any;
  cookieDismiss: any;
  cookieLinkText: any;

  constructor(private analytics: AnalyticsService,
              private seoService: SeoService,
              routingState: RoutingState,
              protected route: ActivatedRoute, 
              protected router: Router, 
              private iconLibraries: NbIconLibraries
              ) {
    
                routingState.loadRouting();
                this.iconLibraries.registerFontPack('font-awesome', { packClass: 'fas', iconClassPrefix: 'fa' });

                let ref = this;
                const parsedUrl = new URL(window.location.href);
            
            // Estrai il percorso (path) e i parametri di query
                const pathWithQuery = parsedUrl.pathname + parsedUrl.search;
            
                //imlementazione riguardante il redirect di idcs
                if(pathWithQuery == '/'){
                  console.log('pathWithQuery slash >> ', pathWithQuery);
                  // ref.routeTo(`auth/shibboleth`);
                } else {
                  console.log('pathWithQuery NO ONLY slash >> ', pathWithQuery);
                  let stringSplit = pathWithQuery.split('?'); //per andare a prendere solo i query params
                  if(stringSplit[1]){
                    console.log('stringSplit[1] >>', stringSplit[1]);
                    let stringSplit2 = stringSplit[1].split('='); //per dividermi la chiave dal valore
                    console.log(stringSplit2);
                    if(stringSplit2[0]=='redirect'){
                      if (stringSplit2[1] && stringSplit2[1].trim()!="") {
                        console.log('ref.idcsAuth >> ', environment.APIendpoint+`/UNISAGatewayRest/rest/idcs/authentication/${stringSplit2[1].trim()}`);
                        window.open(environment.APIendpoint+`/UNISAGatewayRest/rest/idcs/authentication/${stringSplit2[1].trim()}`, '_self');
                        
                      }
                    }
                    
                  }
            
                }
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();

    this.cookieMessage = "Questo sito utilizza cookies, per migliorarne l’esperienza di navigazione, consentire a chi naviga di usufruire di eventuali servizi online e monitorare la navigazione nel sito."
    this.cookieDismiss = "Acconsento"
    this.cookieLinkText = "Cookie Policy"

    let cc = window as any;
       cc.cookieconsent.initialise({
         palette: {
           popup: {
             background: "#164969"
           },
           button: {
             background: "#ffe000",
             text: "#164969"
           }
         },
         theme: "classic",
         position: "bottom",
         content: {
           message: this.cookieMessage,
           dismiss: this.cookieDismiss,
           link: this.cookieLinkText,
           href: "/cookie-policy" 
         }
       });
  }

  routeTo(path: any) {
    this.router.navigate([path]);
  }
}
